module.exports = __webpack_public_path__ + "img/subscription.a1d04238.svg";